import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
import { BlockType } from '../../models/block';
import type { DashboardBlock } from '../../models/block';

type Props = {
  blockType?: BlockType;
  enabled?: boolean;
};

export const useDashboardBlocks = ({
  blockType,
  enabled = true,
}: Props = {}) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchDashboardBlocks = async (): Promise<DashboardBlock[]> => {
    const query = blockType
      ? `?block_type=${encodeURIComponent(blockType)}`
      : '';

    return await api({
      route: `/private/dashboard/blocks/${query}`,
      token: userToken,
    });
  };

  const { data, isLoading, isError } = useQuery<DashboardBlock[], Error>({
    queryKey: ['dashboard-blocks', userToken, blockType],
    queryFn: fetchDashboardBlocks,
    enabled: enabled && isAuthenticated && !loading && !!userToken,
    refetchOnWindowFocus: false,
  });

  return {
    blocks: data ?? [],
    isLoading,
    isError,
  };
};
